import { Box, Text, Image, Button, Flex, Heading, List, ListItem, ListIcon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import bobWordmark from "../assets/logo/bob/bob-wordmark.svg";
import Reveal from "./motion";
import BobPreviewCard from "./BobPreviewCard";
import { HomeContent } from "../data/homeContent";

// Grounded in the same real Business Operations Platform facts as /bob
// (see src/data/bobContent.ts) — a condensed teaser for the homepage, not
// a duplicate of the full product page.

type BobShowcaseProps = { bob: HomeContent["bob"] };

const BobShowcase = ({ bob }: BobShowcaseProps) => (
  <Box as="section" id="bob-product" position="relative" bg="chalk.50" py={{ base: 20, md: 28 }} overflow="hidden">
    <Flex
      position="relative"
      zIndex={1}
      maxW="1400px"
      mx="auto"
      px={{ base: 5, md: 8 }}
      direction={{ base: "column", lg: "row-reverse" }}
      align="center"
      gap={{ base: 12, lg: 20 }}
    >
      <Reveal flex="1">
        <Flex align="flex-end" gap={3} mb={5}>
          <Image w={{ base: "90px", md: "104px" }} src={bobWordmark} alt="bob logó" />
          <Text
            fontSize={{ base: "10px", md: "xs" }}
            fontWeight="700"
            letterSpacing="0.08em"
            textTransform="uppercase"
            color="slate.500"
          >
            {bob.tagline}
          </Text>
        </Flex>

        <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={5}>
          {bob.heading}
        </Heading>

        <Text color="slate.700" fontSize={{ base: "sm", md: "md" }} mb={6} lineHeight="1.8">
          {bob.body}
        </Text>

        <List spacing={3} mb={8}>
          {bob.bullets.map((b) => (
            <ListItem key={b} display="flex" alignItems="flex-start" fontSize="sm" color="ink.900">
              <ListIcon as={CheckCircleIcon} color="bob.300" mt={1} />
              {b}
            </ListItem>
          ))}
        </List>

        <Button
          size="lg"
          bg="bob.300"
          color="bob.900"
          fontWeight="bold"
          as={RouterLink}
          to="/bob"
          _hover={{ bg: "bob.200", transform: "translateY(-2px)" }}
          transition="all 0.2s ease"
        >
          {bob.cta}
        </Button>
      </Reveal>

      <Reveal flex="1" delay={0.15} w="100%">
        <BobPreviewCard />
      </Reveal>
    </Flex>
  </Box>
);

export default BobShowcase;
